<template>
  <!-- 审核数据-->
  <a-modal
    title="审核数据"
    :visible="isVisible"
    :destroyOnClose="true"
    :maskClosable="false"
    :confirm-loading="confirmLoading"
    :dialog-style="{ top: '20px' }"
    width="90%"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <div class="myForm">
      <a-button v-if="buttons" size="small" type="primary" icon="login" @click="goNoteClick">返回</a-button>
      <a-spin :spinning="spinning">
        <div style="height: 500px; overflow: auto">
          <component
            :isChild="true"
            @onClickView="onLoadView"
            :is="getName"
            ref="componentRef"
            @datasChange="datasChange"
            @projectChange="projectChange"
            @largeOrExpenseChange="datasChange"
          />
        </div>
      </a-spin>
      <div
        style="box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1); padding: 5px"
        v-if="status === 4 || status === '4'"
      >
        <a-divider orientation="left">审 核</a-divider>
        <a-form-model
          ref="formRef"
          :model="formData"
          :label-col="labelCol"
          labelAlign="right"
          :wrapper-col="wrapperCol"
        >
          <a-row>
            <!-- <a-col :span="10" :offset="1"> -->
            <a-form-model-item label="审核状态">
              <a-radio-group v-model="formData.checkStatus">
                <a-radio :value="2">通过</a-radio>
                <a-radio :value="3">不通过</a-radio>
              </a-radio-group>
            </a-form-model-item>
          </a-row>
          <!-- </a-col> -->
          <!-- <a-col :span="13"> -->
          <a-row>
            <a-form-model-item label="审核意见/备注">
              <a-textarea
                v-model="formData.checkComment"
                placeholder="请输入审核意见"
                allowClear
                :max-length="1000"
                showCount
                :autosize="{ minRows: 2, maxRows: 20 }"
              />
            </a-form-model-item>
            <!-- </a-col> -->
          </a-row>
        </a-form-model>
      </div>
    </div>
    <!-- 印章效果 -->
    <div v-if="ischeck" class="seal" style="position: absolute; right: 150px;top: 14px;">
      <div class="seal-son">
        <span
          style="position: absolute;top: 36px;text-align: center;font-size: 25px !important;transform: rotate(-30deg);right: 18px;color: #42b983;font-weight: 900;"
        >已审批</span>
      </div>
    </div>
  </a-modal>
</template>

<script>
import db from '@/utils/localstorage'
export default {
  name: 'audit',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      formData: {
        checkStatus: 2
      },
      componentNames: '',
      arr: [],
      buttons: false,
      confirmLoading: false,
      labelCol: { span: 6 },
      rowData: null,
      spinning: false,
      wrapperCol: { span: 18 },
      status: null,
      username: db.get('USER').username,
      ischeck: false // 是否为已审核
      // checkRecordList: [] // 审核记录
    }
  },
  computed: {
    isVisible: {
      get () {
        return this.dialogVisible
      },
      set () {
        this.handleCancel()
      }
    },
    getName () {
      if (this.componentNames) {
        return (resolve) => require([`@/views/${this.componentNames}`], resolve)
      }
      return null
    }
  },
  watch: {
    arr (newVal, oldVal) {
      if (newVal.length <= 1) {
        this.buttons = false
      } else this.buttons = true
    }
  },
  methods: {
    subjectClick (rowVal) {
      this.spinning = true
      if (rowVal.checkType === 0) {
        this.$get('/reimbursement/getById', { id: rowVal.recordId }).then(res => {
          this.componentNames = 'financialManage/expenseReim/show.vue'
          let data = res.data.data
          this.arr.push({ data: data, componentName: this.componentNames, titles: 'xx' })
          this.rowData = data
        }).finally(_ => {
          this.componentNames = 'financialManage/expenseReim/show.vue'
        })
      } else if (rowVal.checkType === 1) {
        // 采购单---抽屉信息
        this.componentNames = 'purchase/purchaseNote/viewDrawer.vue'
        this.arr.push({ data: rowVal.recordId, componentName: this.componentNames, titles: 'xx' })
        this.rowData = rowVal.recordId
      } else if (rowVal.checkType === 2) {
        this.$get('/prePayment/getById', { id: rowVal.recordId }).then(res => {
          // 预支预付
          if (res.data.status === 1) {
            this.componentNames = 'financialManage/advance/show.vue'
            this.arr.push({ data: res.data.data, componentName: this.componentNames, titles: 'xx' })
            this.rowData = res.data.data
          }
        }).finally(_ => {
          this.componentNames = 'financialManage/advance/show.vue'
        })
      } else if (rowVal.checkType === 3 || rowVal.checkType === 4) {
        // 付款回款
        if (rowVal.isBack === 0) {
          this.$get('/payBack/getById', { backType: 1, id: rowVal.recordId }).then(res => {
            if (res.data.status === 1) {
              this.componentNames = 'contractManage/paymentRecord/show.vue'
              this.arr.push({ data: res.data.data, componentName: this.componentNames, titles: 'xx' })
              this.rowData = res.data.data
            }
          }).finally(_ => {
            this.componentNames = 'contractManage/paymentRecord/show.vue'
          })
        } else if (rowVal.isBack === 1) {
          this.$get('/payPlan/getById', { payType: 0, id: rowVal.recordId }).then(res => {
            if (res.data.status === 1) {
              this.componentNames = 'purchase/paymentSchedule/paymentInfor.vue'
              this.arr.push({ data: res.data.data, componentName: this.componentNames, titles: 'xx' })
              this.rowData = res.data.data
            }
          }).finally(_ => {
            this.componentNames = 'purchase/paymentSchedule/paymentInfor.vue'
          })
        }
      } else if (rowVal.checkType === 5) {
        // 外出
        //
        this.$get('outwork/byId', { id: rowVal.recordId }).then(res => {
          if (res.data.status === 1) {
            this.componentNames = 'offices/travelRecords/details.vue'
            this.arr.push({ data: res.data.data, componentName: this.componentNames, titles: 'xx' })
            this.rowData = res.data.data
          }
        }).finally(_ => {
          this.componentNames = 'offices/travelRecords/details.vue'
        })
      } else if (rowVal.checkType === 6) {
        // 加班
        this.$get('workOverTime/byId', { id: rowVal.recordId }).then(res => {
          if (res.data.status === 1) {
            this.componentNames = 'offices/overtimeRecords/details.vue'
            this.arr.push({ data: res.data.data, componentName: this.componentNames, titles: 'xx' })
            this.rowData = res.data.data
          }
        }).finally(_ => {
          this.componentNames = 'offices/overtimeRecords/details.vue'
        })
      } else if (rowVal.checkType === 7) {
        // 大额申请
        this.$get('bigAmount/byId', { id: rowVal.recordId }).then(res => {
          if (res.data.status === 1) {
            this.componentNames = 'financialManage/largeAmountApplication/show.vue'
            this.arr.push({ data: res.data.data, componentName: this.componentNames, titles: 'xx' })
            this.rowData = res.data.data
          }
        }).finally(_ => {
          this.componentNames = 'financialManage/largeAmountApplication/show.vue'
        })
      } else if (rowVal.checkType === 8) {
        // 项目立项申请
        this.$get('/projectApproval/getById', { id: rowVal.recordId }).then(res => {
          if (res.data.status === 1) {
            this.componentNames = 'projectManage/projectProposals/detail.vue'
            this.arr.push({ data: res.data.data, componentName: this.componentNames, titles: 'xx' })
            this.rowData = res.data.data
          }
        }).finally(_ => {
          this.componentNames = 'projectManage/projectProposals/detail.vue'
        })
      } else if (rowVal.checkType === 9) {
        // 节礼申请
        this.$get('/festivalGift/getById', { id: rowVal.recordId }).then(res => {
          if (res.data.status === 1) {
            this.componentNames = 'offices/courtesyApplication/details.vue'
            this.arr.push({ data: res.data.data, componentName: this.componentNames, titles: '节礼申请' })
            this.rowData = res.data.data
          }
        }).finally(_ => {
          this.componentNames = 'offices/courtesyApplication/details.vue'
        })
      } else if (rowVal.checkType === 10) {
        // 资产领用
        this.$get('/stockReceive/getById', { id: rowVal.recordId }).then(res => {
          if (res.data.status === 1) {
            this.componentNames = 'inventory/takeItBack/details.vue'
            this.arr.push({ data: res.data.data, componentName: this.componentNames, titles: '资产领用' })
            this.rowData = res.data.data
          }
        }).finally(_ => {
          this.componentNames = 'inventory/takeItBack/details.vue'
        })
      } else if (rowVal.checkType === 11) {
        // 采购申请
        this.$get('/purchaseRequisition/getById', { id: rowVal.recordId }).then(res => {
          if (res.data.status === 1) {
            this.componentNames = 'purchase/purchaseRequest/show.vue'
            this.arr.push({ data: res.data.data, componentName: this.componentNames, titles: '采购申请' })
            this.rowData = res.data.data
          }
        }).finally(_ => {
          this.componentNames = 'purchase/purchaseRequest/show.vue'
        })
      } else if (rowVal.checkType === 12) {
        // 招聘需求
        this.$get('/recruitment/getById', { id: rowVal.recordId }).then(res => {
          if (res.data.status === 1) {
            this.componentNames = 'manpower/recruitmentDemand/details.vue'
            this.arr.push({ data: res.data.data, componentName: this.componentNames, titles: '招聘需求' })
            this.rowData = res.data.data
          }
        }).finally(_ => {
          this.componentNames = 'manpower/recruitmentDemand/details.vue'
        })
      } else if (rowVal.checkType === 13) {
        // 保证金
        this.$get('/performance/getById', { id: rowVal.recordId }).then(res => {
          if (res.data.status === 1) {
            this.componentNames = 'contractManage/earnestMoney/details.vue'
            this.arr.push({ data: res.data.data, componentName: this.componentNames, titles: '保证金' })
            this.rowData = res.data.data
          }
        }).finally(_ => {
          this.componentNames = 'contractManage/earnestMoney/details.vue'
        })
      } else if (rowVal.checkType === 14) {
        // 出车
        this.$get('/outCar/byId', { id: rowVal.recordId }).then(res => {
          if (res.data.status === 1) {
            this.componentNames = 'offices/vehicleDepartureRecord/details.vue'
            this.arr.push({ data: res.data.data, componentName: this.componentNames, titles: '出车登记' })
            this.rowData = res.data.data
          }
        }).finally(_ => {
          this.componentNames = 'offices/vehicleDepartureRecord/details.vue'
        })
      } else if (rowVal.checkType === 15) {
        // 出车
        this.$get('/returnCar/byId', { id: rowVal.recordId }).then(res => {
          if (res.data.status === 1) {
            this.componentNames = 'offices/returnCarRecord/details.vue'
            this.arr.push({ data: res.data.data, componentName: this.componentNames, titles: '还车记录' })
            this.rowData = res.data.data
          }
        }).finally(_ => {
          this.componentNames = 'offices/returnCarRecord/details.vue'
        })
      }
    },
    onLoadView () {
      //
      if (this.arr.length <= 1) {
        this.spinning = false
        this.$refs.componentRef.setFormData(this.rowData)
      }
      //
    },
    setId (valObj, checkType) {
      //
      this.subjectClick(valObj)
      // this.status = valObj.status
      this.getStatus(valObj.id)
      this.formData.checkId = valObj.recordId
      this.formData.id = valObj.id
      this.formData.checkType = valObj.checkType
      if (this.formData.checkType === 3 || this.formData.checkType === 4) {
        this.formData.isBack = valObj.isBack
      } else {
        this.formData.isBack = null
      }
      this.$get('/history/list', {
        recordId: this.formData.checkId,
        checkType: this.formData.checkType,
        historyType: 1,
        pageSize: -1,
        pageNum: -1
      }).then(res => {
        if (res.data.status === 1) {
          let resData = res.data.data.records
          let arr = []
          if (resData && resData.length > 0) {
            resData.forEach(element => {
              if (element.checkStatus === 2 || element.checkStatus === 3) {
                arr.push(element)
              }
            })
          }
          arr.forEach(e => {
            if (e.creator === this.username) {
              this.ischeck = true
            }
          })
          // this.checkRecordList = arr
          //
        } else {
          this.$message.warning(res.data.message)
        }
      })
    },
    // 获取审核状态数据
    getStatus (id) {
      this.$get('/checkDetail/getById', { id: id }).then(res => {
        // alert(JSON.stringify(res.data.data))

        this.status = res.data.data.status
      })
    },
    goNoteClick () {
      this.arr.pop()
      let item = this.arr[this.arr.length - 1]
      //
      this.datasChange(item.data, item.componentName, item.titles, 0)
    },
    handleOk () {
      if (this.status !== 4 && this.status !== '4') {
        this.$emit('close')
        this.reset()
        return
      }
      this.confirmLoading = true
      this.$post('/checkDetail/check', this.formData).then(res => {
        if (res.data.status === 1) {
          this.$message.success(res.data.message)
          this.$emit('success')
          this.reset()
        } else {
          this.$message.warning(res.data.message)
        }
      }).finally(_ => {
        this.confirmLoading = false
      })
    },
    handleCancel () {
      this.$emit('close')
      this.reset()
    },
    reset () {
      this.buttons = true
      this.arr = []
      this.rowData = null
      this.status = null
      this.ischeck = false
      this.componentNames = ''
      this.formData = {
        checkStatus: 2
      }
    },
    projectChange (value, name) {
      this.$emit('projectChanges', value, name)
    },
    datasChange (data, componentName, title, num) {
      this.componentNames = componentName
      if (num !== 0) {
        this.arr.push({ data: data, componentName: componentName, titles: title })
      }
      //
      setTimeout(() => {
        if (this.$refs.componentRef) {
          //
          this.$refs.componentRef.setFormData(data)
        }
      }, 300)
    }
  }
}
</script>

<style lang="less" scoped>
// /deep/ .ant-form-item .ant-form-item-label {
//   width: auto !important;
// }
/deep/ .ant-divider-with-text-left:before {
  border-top: 1px solid #47b682 !important;
}
/deep/ .ant-divider-with-text-left:after {
  border-top: 1px solid #47b682 !important;
}
.seal {
  width: 130px;
  height: 130px;
  border: solid 5px #42b983;
  border-radius: 100%;
  background-color: #fff;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}
.seal-son {
  width: 115px;
  height: 115px;
  border: solid 2px #42b983;
  border-radius: 100%;
  background-color: rgba(66, 185, 131, 0.2);
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/views/approvalManage/approvalData/audit.vue